import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";

// The Misc Analysis "research" and "proposal-writing" editor views are surfaces over the
// same MISC_ANALYSIS entity — their documents are stored in document_queue under
// MISC_ANALYSIS. Backend endpoints that resolve entityType against the storage enum
// (document_entity_type) need these editor-view identifiers mapped to their canonical
// storage type before they leave the client. Mirrors the getDisplayContext mapping used
// for prompts.
const STORAGE_ENTITY_TYPE_BY_VIEW = {
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_RESEARCH]:
    UPLOAD_ENTITY_TYPES.MISC_ANALYSIS,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING]:
    UPLOAD_ENTITY_TYPES.MISC_ANALYSIS,
};

const toStorageEntityType = (entityType) =>
  STORAGE_ENTITY_TYPE_BY_VIEW[entityType] || entityType;

export default toStorageEntityType;
